const HEADERS = [
  'Engineer', 'Closed', 'Open', 'Avg Resolution (h)', 'First Response (m)',
  'SLA %', 'CSAT (1-3)', 'Flags', 'Top Category', 'Low Sample',
];

function cell(value) {
  if (value === null || value === undefined) return '';
  const s = String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function buildLeaderboardCsv(engineers) {
  const rows = (engineers || []).map((e) => [
    e.name, e.closed, e.open, e.avg_resolution_hours, e.avg_first_response_minutes,
    e.sla_met_pct, e.avg_satisfaction, e.flag_count, e.top_category,
    e.low_sample ? 'yes' : 'no',
  ].map(cell).join(','));
  return [HEADERS.join(','), ...rows].join('\n');
}
